import CellChipStatus from "./CellChipStatus";
import { getTestNurturingJourneyResultStatus } from "app/utils/nurturingTestAutomationProgressUtils";

interface CellTestNurturingAutomationStatusProps {
  params: any;
}

const CellTestNurturingAutomationStatus = ({
  params,
}: CellTestNurturingAutomationStatusProps) => {
  const result = getTestNurturingJourneyResultStatus(
    params?.row?.messages_sent_count,
    params?.row?.expected_sent_count,
  );
  const normalizedStatus = result === "success" ? "SUCCESS" : "FAILED";

  return <CellChipStatus>{normalizedStatus}</CellChipStatus>;
};

export default CellTestNurturingAutomationStatus;
